import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';

// Initialize SpeechRecognition
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = SpeechRecognition ? new SpeechRecognition() : null;

const GeneralPronunciation = () => {
  const [name, setName] = useState('');
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [spokenWord, setSpokenWord] = useState('');
  const [score, setScore] = useState(null);
  const [scoreboard, setScoreboard] = useState([]);
  const [isListening, setIsListening] = useState(false);

  useEffect(() => {
    if (recognition) {
      recognition.continuous = false;
      recognition.lang = 'en-ZA';

      recognition.onresult = (event) => {
        const spoken = event.results[0][0].transcript.toLowerCase();
        setSpokenWord(spoken);
        calculateScore(spoken);
        setIsListening(false);
      };

      recognition.onerror = (event) => {
        console.error('Speech Recognition Error:', event.error);
        setIsListening(false);
      };
    }
  }, []);

  // Handle input change for the pronunciation part
  const handleInputChange = (e) => {
    setName(e.target.value);
  };

  // Pronounce the entered name
  const pronounceName = () => {
    if ('speechSynthesis' in window) {
      // Cancel any ongoing speech to avoid overlapping
      window.speechSynthesis.cancel();
      
      const utterance = new SpeechSynthesisUtterance(name);
      utterance.lang = 'en-ZA';
      utterance.rate = 0.4;

      utterance.onstart = () => setIsSpeaking(true);
      utterance.onend = () => setIsSpeaking(false);
      utterance.onerror = () => setIsSpeaking(false);

      // Ensure voices are loaded before speaking
      if (window.speechSynthesis.getVoices().length === 0) {
        window.speechSynthesis.onvoiceschanged = () => {
          window.speechSynthesis.speak(utterance);
        };
      } else {
        window.speechSynthesis.speak(utterance);
      }
    }
  };

  // Start listening for speech input
  const startListening = () => {
    if (recognition) {
      setSpokenWord(''); // Clear previous spoken word
      recognition.start();
      setIsListening(true);
    } else {
      alert('Speech recognition is not supported in this browser.');
    }
  };

  // Calculate a simple score based on length and clarity of the word
  const calculateScore = (spoken) => {
    const wordLength = spoken.length;
    let rating = Math.min(5, Math.ceil(wordLength / 2)); // Simple scoring based on word length

    setScore(rating);
    updateScoreboard(spoken, rating);
  };

  // Update scoreboard with the latest result (most recent on top)
  const updateScoreboard = (spoken, rating) => {
    setScoreboard((prev) => [
      { spokenWord: spoken, score: rating },
      ...prev
    ]);
  };

  const btnStyle = {
    margin: '5px',
    padding: '4px 8px',
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer'
  };

  const bigBtnStyle = {
    margin: '5px',
    padding: '4px 8px',
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer'
  };

  return (
    <div className="pronunciation-container">
      <h2>Pronunciation App</h2>
      
      {/* Pronunciation Part */}
      <div className="pronunciation-section">
        <h3>Enter a Name for Pronunciation</h3>
        <input
          type="text"
          value={name}
          onChange={handleInputChange}
          placeholder="Enter name"
          disabled={isSpeaking}
        />
        <button onClick={pronounceName} disabled={isSpeaking || !name} style={btnStyle}>
          {isSpeaking ? 'Pronouncing...' : 'Pronounce'}
        </button>
      </div>

      {/* Speech Recognition Part */}
      <div className="speech-recognition-section">
        <h3>Speak Word(s) en-ZA</h3>
        <button onClick={startListening} disabled={isListening} style={bigBtnStyle}>
          <Icon icon="material-symbols:spatial-speaker-rounded" width="24" height="24" />   
          {isListening ? ' Listening...' : ' Start Speaking'}
        </button>
        {spokenWord && <p>You said: "{spokenWord}"</p>}
        {score !== null && <p>Your score: {score}/5</p>}
      </div>

      {/* Scoreboard */}
      <div className="scoreboard-section">
        <h3>Scoreboard</h3>
        <table border="1" cellPadding="10">
          <thead>
            <tr>
              <th>Spoken Word(s)</th>
              <th>Score (out of 5)</th>
            </tr>
          </thead>
          <tbody>
            {scoreboard.map((entry, index) => (
              <tr key={index}>
                <td>{entry.spokenWord}</td>
                <td>{entry.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GeneralPronunciation;
